import { createTheme, PaletteColorOptions } from '@mui/material';

declare module '@mui/material/styles' {
    interface Palette {
        appBackground: PaletteColor;
        listItemButton: PaletteColor;
        listItemBackground: PaletteColor;
        cardSubtitle: PaletteColor;
        globalSwitch: PaletteColor;
        loginBackground: PaletteColor;
    }

    interface PaletteColor {
        //Shade of the main color
        shade?: string;

        //Disabled colors for front-elemtns and background
        disabled?: string;
        disabledBg?: string;

        //Enabled colors for front-elements and background
        enabled?: string;
        enabledBg?: string;

        //Hover color
        hoverMain?: string;
    }
    interface PaletteOptions {
        appBackground: PaletteColorOptions;
        listItemButton: PaletteColorOptions;
        listItemBackground: PaletteColorOptions;
        cardSubtitle: PaletteColorOptions;
        globalSwitch: PaletteColorOptions;
        loginBackground: PaletteColorOptions;
    }

    interface SimplePaletteColorOptions {
        //Shade of the main color
        shade?: string;

        //Disabled colors for front-elements and background
        disabled?: string;
        disabledBg?: string;

        //Enabled colors for front-elements and background
        enabled?: string;
        enabledBg?: string;

        //Hover color
        hoverMain?: string;
    }
}

const theme = createTheme({
    palette: {
        primary: {
            light: '#FFF',
            main: '#208CFF',
            dark: '#000'
        },
        secondary: {
            main: '#232A3F',
            light: '#002254'
        },
        appBackground: {
            main: '#F5F5F5'
        },
        cardSubtitle: {
            main: '#979797'
        },
        listItemButton: {
            main: '#208CFF',
            hoverMain: '#1d7ee6'
        },
        listItemBackground: {
            main: '#FFF',
            shade: '#EFEFEF'
        },
        globalSwitch: {
            main: '#FFF',
            disabledBg: '#A6ABBD',
            enabledBg: '#208CFF'
        },
        loginBackground: {
            main: 'radial-gradient(57.91% 57.91% at 50% 42.09%, rgba(32, 140, 255, 0.15) 24.22%, rgba(0, 0, 0, 0) 100%),linear-gradient(0deg, #232A3F, #232A3F)'
        }
    },
    typography: {
        h1: {
            fontSize: '1.25rem',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '1.75rem'
        },
        h2: {
            fontSize: '1.125rem',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: '1.875rem'
        },
        h3: {
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '1.75rem'
        },
        h4: {
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '1.625rem'
        },
        h5: {
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '1.625rem'
        },
        h6: {
            fontSize: '0.813rem',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '1.625rem'
        },
        button: {
            textTransform: 'none',
            fontWeight: 600
        },
        fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Open Sans"', 'sans-serif'].join(','),
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        fontWeightBold: 700
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 900,
            lg: 1024,
            xl: 1200
        }
    },
    components: {
        MuiTypography: {
            defaultProps: {
                color: '#232A3F'
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
});

export default theme;
